import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { ISettingsBlockProps } from './settings-block';

const SettingsBlock = lazy(async () => import('./settings-block'));

const el = '.fa-component--settings-block';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as ISettingsBlockProps;

            createRoot(component).render(<SettingsBlock {...props} />);
        });
    }
};

export default {
    render,
};
